var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticStyle:{"background":"'red'"}},[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'booking-add'},"title":_vm.$t('menuitems.booking.text')}}),_c('List',{attrs:{"dataList":_vm.bookingData,"edit":{link: 'booking-edit'},"more":{
          sub: [{
          //  name: 'property.contract', link: 'property-contract', column: 'id'
          //}, {
             name: 'property.sell', icon:'bx bx-cart', link: 'sale/add', query: 'bookingid', column: 'id' //, show: {column: 'property_status_id', value: 1}
          }, {
            name: 'booking.delay', icon:'bx bx-time-five', link: 'property-book-delay', column: 'id'
          }, {
            name: 'booking.extend', icon:'bx bx-fullscreen', link: 'booking-extend', column: 'id'
          }, {
            name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property/cancelation', query: 'bookingid', column: 'id'
          }, {
            name: 'booking.transfer-property.text', icon: 'bx bx-sync', link: 'booking-transfer', column: 'id'
          }, {
            name: 'payment.receipt', icon:'bx bx-receipt', link: 'booking-receipt', column: 'id'
          }]

        },"filter":{
          search: ['bookings.code', 'customers.name', 'customers.name_en', 'properties.code'],
          dropdown: [{
            title: 'property.project',
            field: 'properties.project_id',
            data: this.projectData.data,
            method: function (event) { return _vm.projectChanged(event); },
            default: 1,
            width: 2
          }, {
            title: 'property.group',
            field: 'properties.property_group_id',
            data: this.groupData.data,
          }, {
            title: 'property.floor',
            field: 'properties.project_floor_id',
            show: 'number',
            data: this.floorData.data,
          }],
          date: {
            title: 'general.date',
            field: 'bookings.booking_date'
          }
        },"module":'booking',"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'currency_en'}, {name: 'booking_date', type: 'date'}, {name: 'expire_date', type: 'date'}, 
                  {name: 'price', type: 'currency'}, {name: 'discount', type: 'currency'},  
                  {name: 'booking_amount', type: 'currency'}, {name: 'sale_price', type: 'currency'}],"fields":[ ("code: " + (_vm.$t('booking.code'))), ("customer: " + (_vm.$t('customer.text'))), 
          ("property: " + (_vm.$t('property.text'))), ("booking_date: " + (_vm.$t('general.date'))), ("currency_en: " + (_vm.$t('property.currency'))), 
          ("price: " + (_vm.$t('booking.price'))), // Price
          ("discount: " + (_vm.$t('booking.discount'))), // Discount
          ("sale_price: " + (_vm.$t('booking.sale-price'))), // Sale Price
          ("booking_amount: " + (_vm.$t('booking.deposit'))),  // Deposit
          ("expire_date: " + (_vm.$t('booking.expired')))]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }